import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_CalocusScoresheet = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_CalocusScoresheet' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Member Name:</span>
                            <input type='text' id='txtMemberName' name='txtMemberName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Medicaid Number:</span>
                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>CALOCUS SCORE SHEET :</h2></p>

                <table>
                    <tr>
                        <td className='w-50'></td>
                        <td className='w-500'><span className='eleHeader'><b>DIMENSIONS</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>CURRENT</b></span></td>
                        <td className='w-100'><span className='eleHeader'><b>CRITERIA</b></span></td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>I</b></td>
                        <td className='w-500'><span>RISK OF HARM</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_1' name='txtCurrent_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_1' name='txtCriteria_1' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>II</b></td>
                        <td className='w-500'><span>FUNCTIONAL STATUS</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_2' name='txtCurrent_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_2' name='txtCriteria_2' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>III</b></td>
                        <td className='w-500'><span>CO-MORBIDITY: DEVELOPMENTAL, MEDICAL, SUBSTANCE USE AND PSYCHIATRIC</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_3' name='txtCurrent_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_3' name='txtCriteria_3' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>IV-A</b></td>
                        <td className='w-500'><span>RECOVERY ENVIRONMENT (STRESS)</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_4' name='txtCurrent_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_4' name='txtCriteria_4' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>IV-B</b></td>
                        <td className='w-500'><span>RECOVERY ENVIRONMENT (SUPPORT)</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_5' name='txtCurrent_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_5' name='txtCriteria_5' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>V</b></td>
                        <td className='w-500'><span>RESILIENCY AND TREATMENT HISTORY</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_6' name='txtCurrent_6' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_6' name='txtCriteria_6' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>VI-A</b></td>
                        <td className='w-500'><span>TREATMENT ACCEPTANCE AND ENGAGEMENT (CHILD OR ADOLESCENT)</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_7' name='txtCurrent_7' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_7' name='txtCriteria_7' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-50'><b>VI-B</b></td>
                        <td className='w-500'><span>TREATMENT ACCEPTANCE AND ENGAGEMENT (PARENTAL AND/OR PRIMARY CARETAKER)</span></td>
                        <td className='w-100'>
                            <input type='text' id='txtCurrent_8' name='txtCurrent_8' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtCriteria_8' name='txtCriteria_8' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-400'></td>
                        <td className='w-150'><b>COMPOSITE SCORE:</b></td>
                        <td className='w-200'>
                            <input type='text' id='txtScore' name='txtScore' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>LEVEL OF CARE RECOMMENDED:</span>
                    <textarea id='txtRecommended' name='txtRecommended' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'></td>
                        <td className='signature w-375'></td>
                    </tr>
                    <tr>
                        <td className='small w-375'>LMHP PRINTED NAME
                        </td>
                        <td className='small w-375'>LMHP SIGNATURE / DATE
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











